export enum ConversationAction {
  Delete = 'delete',
  Create = 'create',
}
